import { Media, Spacing, StackChildren } from '@doordash/design-language'
import styled from 'styled-components'

export const FormContainer = styled.div`
  position: absolute;
  top: ${Spacing.XxxxLarge}px;
  right: ${Spacing.XxLarge}px;
  z-index: 1;

  ${Media.WideScreen`
    margin: ${Spacing.Large}px auto 0;
    position: inherit;
    display: flex;
    justify-content: center;
  `}
`

export const JobSectionContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const HomeDescriptionContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  margin: ${Spacing.XxxLarge}px ${Spacing.XLarge}px ${Spacing.XxxLarge}px
    ${Spacing.XLarge}px;
`

export const HomeDescriptionStack = styled(StackChildren)`
  flex-basis: 40rem;
`

export const BreadcrumbsContainer = styled.div`
  padding-top: ${Spacing.Small}px;
`
